const Types = {
  SET_FB_AUTH_STATE: '@instagram/SET_FB_AUTH_STATE',
  SET_FB_SELECTED_PAGE: '@instagram/SET_FB_SELECTED_PAGE',
  SET_FB_CHANNEL_DATA: '@instagram/SET_FB_CHANNEL_DATA',
  SET_FB_IS_LOGGED: '@instagram/SET_FB_IS_LOGGED',
};

export default Types;
